module.exports = __webpack_public_path__ + "static/img/banner.bc5aa43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner.png
// module id = 7E6U
// module chunks = 1